import { styled } from '@mui/material';

import { ActionButton } from 'components/system/buttons';
import { colorByType, TToastType } from '../toast.constants';

export const StyledButton = styled(ActionButton, {
  shouldForwardProp: (prop) => prop !== 'toastType',
})<{ toastType: TToastType }>(({ toastType, theme }) => ({
  fontSize: theme.typography.textBase.fontSize,
  fontWeight: '700',
  color: colorByType[toastType],
  padding: theme.spacing(3, 6),
}));
